import styled from 'styled-components'
import { List as ListAnt } from 'antd'

export const List = styled(ListAnt)`
  .ant-list-item:last-child {
    border-bottom: 1px solid #e8e8e8;
  }
  .ant-list-header {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    background-color: #fafafa;
    justify-content: space-between;
    padding: 8px 2px;
    color: rgba(0, 0, 0, 0.85);
    div {
      width: 25%;
      text-align: center;
    }
  }
` as React.ComponentType as new <T>() => ListAnt<T>

export const ListAntItem = styled(ListAnt.Item)<{ odd?: number }>`
  background-color: ${({ odd }) => (odd === 1 ? '#fafafa' : 'white')};
  padding: 0;
  width: 100%;
`

export const ListAntItemJustification = styled.div`
  width: 100%;
  padding: 4px 16px;
  font-size: 10px;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const ListAntItemSingle = styled.div`
  display: flex;
  span {
    width: 25%;
    text-align: center;
    padding: 4px 2px;
    font-size: 10px;
    line-height: 1.2;
  }
`
